import { useContext, useEffect } from "react";
import { FaGreaterThan } from "react-icons/fa";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AlertContext from "../../../context/Alert/AlertContext";
import AuthContext from "../../../context/Auth/AuthContext";
import styles from "./Order.module.css";
import OrderTable from "./OrderTable";
import { Link } from "react-router-dom";
import PendingOrderTable from "./PendingOrderTable";

const PendingOrder = () => {
  const { authPermissions } = useContext(AuthContext);
  const { alertMessage, setAlertMessage } = useContext(AlertContext);

  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const userRole = userDetails.roles;

  const headers1 = [
    { name: "ORDER NO.", field: "order_no", sortable: true, classKey: "" },
    {
      name: "DEALER NAME",
      field: "dealer_name",
      sortable: true,
      classKey: "",
    },
    {
      name: "ORDERED BY",
      field: "order_punched_by",
      sortable: true,
      classKey: "",
    },
    {
      name: "Order Date",
      field: "order_date",
      sortable: true,
      classKey: "",
    },
    { name: "AMOUNT (₹)", field: "total_amount", sortable: true, classKey: "" },
    {
      name: "STATUS",
      field: "order_status",
      sortable: true,
      classKey: "",
    },

    { name: "ACTION", field: "action", classKey: "" },
  ];

  const headers2 = [
    { name: "ORDER NO.", field: "order_no", sortable: true, classKey: "" },

    {
      name: "Order Date",
      field: "order_date",
      sortable: true,
      classKey: "",
    },
    { name: "AMOUNT (₹)", field: "total_amount", sortable: true, classKey: "" },
    {
      name: "STATUS",
      field: "order_status",
      sortable: true,
      classKey: "",
    },

    { name: "ACTION", field: "action", classKey: "" },
  ];

  // alert message
  useEffect(() => {
    if (alertMessage != null) {
      toast(alertMessage.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      setAlertMessage(null);
    }
  }, [alertMessage]);

  return (
    <>
      <div className="section-body">
        <div className="container-fluid" style={{ padding: "0px" }}>
          <div className="mx-sm-3 mx-0">
            {/* heading and add button */}
            <div className="d-flex justify-content-between align-items-center ">
              {/* hearder breadcrumb */}
              <div className="card-header">
                <strong className="top-left-heading">Orders</strong>

                <ol
                  className="headerroutes breadcrumb m-0 bg-none "
                  style={{ flexWrap: "nowrap" }}
                >
                  <li className="item color-gray">|</li>
                  <li className="item">
                    <Link
                      to="/admin/dashboard"
                      className="route-heading item mx-2"
                    >
                      Dashboard
                    </Link>
                  </li>
                  <li className="item">
                    <FaGreaterThan className="grater-than-route" />
                  </li>
                  <li className="route-heading item ml-2 mr-sm-2 mr-0 mt-1">
                    Pending Orders
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        <div className="section-body ">
          <div className="container-fluid">
            <div className="tab-content ">
              <div
                className="tab-pane fade show active"
                id="order-list"
                role="tabpanel"
              >
                <div className="card">
                  <div className="card-body">
                    <div className="table-responsive">
                      {
                        <PendingOrderTable
                          headers={userRole !== "dealer" ? headers1 : headers2}
                        />
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PendingOrder;
